import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=eb68b624&scoped=true"
import script from "./recordDetail.vue?vue&type=script&lang=js"
export * from "./recordDetail.vue?vue&type=script&lang=js"
import style0 from "./recordDetail.vue?vue&type=style&index=0&id=eb68b624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb68b624",
  null
  
)

export default component.exports